import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { Alert } from 'react-bootstrap';

function Grilla (props){
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [idcasino, setIdCasino] = useState()
    const [nombrecasino, setNombreCasino] = useState()
    const [direccioncasino, setDireccionCasino] = useState('')
    const [valorticketcasino, setValorTicketCasino] = useState('')
    const [empresacasino, setEmpresaCasino] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')    
    let statuscall = '' 
    
    const dataList = datos.map((item, i) => 
    <div key={i} className='boLineGrilla'>
         <div className='boLineIndexGrilla'>{i + 1}</div>
         <div className='boLinePrincipalContentGrilla'>{item.nombre}</div>
         <div className='boLinePrincipalContentGrilla'>{item.direccion}</div>
         <div className='boLinePrincipalContentGrilla'>$ {item.value_ticket}</div>
         <div className='boLinePrincipalContentGrilla'><button onClick={() => clickCasino(item)}>Modificar</button></div>
    </div>);


    const handleDireccion = async (e) =>{
        setDireccionCasino(e.target.value)
    }    

    const handleValorTicket = async (e) =>{
        setValorTicketCasino(e.target.value)
    }

    const putCasino = async () =>{
        setClassWaitProcess('waitProcessV')
        
        if(direccioncasino != '')
        {
            if(valorticketcasino != '')
            {
                let urlput = process.env.REACT_APP_URLPUTCASINO+idcasino.toString()+'/update'
                let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                const data = {   
                    direccion: direccioncasino,
                    value_ticket: valorticketcasino,
                }
        
                const casinoPut = await Axios.put(urlput, data, {
                    timeout: process.env.REACT_APP_TIMEOUT,
                    headers: {
                        'Access-Control-Allow-Origin' : '*',
                        'Access-Control-Allow-Methods': 'GET, POST',
                        'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                    
                if(statuscall.status == 200)
                {   
                    setClassWaitProcess('waitProcess')
                    handleGrillaCasino()
                    setTituloAlert('Modidifacion de casinos')
                    setTextoAlert('Casino actualizado')
                    setClaseAlert('success alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 3000)

                    setTimeout(() =>{
                        handleClose()
                    }, 3500)
                }
                else
                {
                    if(statuscall.status == 0)
                    {
                        setClassWaitProcess('waitProcess')
                        setTituloAlert('Modidifacion de casinos')
                        setTextoAlert('Servidor no responde. Intentelo mas tarde')
                        setClaseAlert('danger alertFlotante opacity-100')
                        setAlert(true)
                        setTimeout(() => {
                            setAlert(false)
                        }, 4000)                        
                    }
                }
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Modidifacion de casino')
                setTextoAlert('Debe ingresar el valor del ticket')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 4000)
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Modidifacion de casino')
            setTextoAlert('Debe ingresar una dirección')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 4000)
        }
    }

    const handleGrillaCasino = async () =>{
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data)
            setDatosBackup(response.data)
        }).catch(error => {
            return error     
        });
    }

    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data)
            setDatosBackup(response.data)
        }).catch(error => {
            return error     
        });
    }, []);

    const clickCasino= (item) =>{
        setIdCasino(item.id)
        setNombreCasino(item.nombre)
        setDireccionCasino(item.direccion)
        setValorTicketCasino(item.value_ticket)
        setEmpresaCasino(item.enterprise_id)
        handleShow()
    }

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        console.log("Busqueda: " + e.target.value)
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataNombre = item.nombre.toUpperCase()
                const campo = itemDataNombre
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
        console.log(newData)
        console.log(datos)
    }

    return(
    <div className='boSeccionGrilla'>
        <div className='boSeccionGrillaTitle'>
            Lista Casinos
        </div>
        <div className='boSeccionGrillaSearch'>
            <input type='search' onChange={handleChangeList} placeholder='Buscar'></input>
        </div>

        <div className='boGrilla'>
            <div className='boLineGrillaTitulo'>
                <div className='boLineIndexGrilla'>T</div>
                <div className='boLinePrincipalContentGrilla'>Nombre</div>
                <div className='boLinePrincipalContentGrilla'>Dirección</div>
                <div className='boLinePrincipalContentGrilla'>Valor Ticket</div>
                <div className='boLinePrincipalContentGrilla'>Controles</div>
            </div>

            {dataList}
        </div>

        <div className='row'>
            <div className='col col-lg-12'>
                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Crear Casino</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className={classWaitProcess}>
                            <div className='loaderS divAbsolute'>
                            </div>
                        </div>

                        <div className='row divAbsolute'>
                            <div className='col col-lg-12'>
                            {alert
                            ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                                <Alert.Heading>{tituloAlert}</Alert.Heading>
                                    <p>
                                        {textoAlert}
                                    </p>
                            </Alert>
                            :''
                            }
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                                Nombre casino                                                                    
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' disabled='true' value={nombrecasino}></input>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col col-lg-4'>
                                Direccion casino     
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' onChange={handleDireccion} value={direccioncasino}></input>
                            
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col col-lg-4'>
                                Valor Ticket                                                                    
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' 
                                onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }
                                }
                                onChange={handleValorTicket}  
                                value={valorticketcasino}></input>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col col-lg-4'>
                                Empresa casino                                                                    
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' disabled='true' value={empresacasino}></input>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={handleClose}>
                            Cerrar
                        </button>
                        <button onClick={putCasino}>
                            Modificar
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
                                                                                                                                                                                           
    </div>    
    )
}
export default Grilla